/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AgentStatuses } from './agent-statuses';


export interface AgentByIdResponse { 
    id: string;
    name: string;
    facilityId?: string;
    facilityName?: string | null;
    status: AgentStatuses;
    comment?: string | null;
    version?: string | null;
    lastHeartbeatAt?: string | null;
    createdDate: string;
    isApproved: boolean;
}



